import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  value: {
    fontSize: 15,
    fontWeight: 400,
    color: '#fff',
  },
  column: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 20,
    padding: 10,
  },
  flexWrap: {
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  barWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  label: {
    marginRight: 20,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      marginRight: 0,
      marginBottom: 10,
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 40,
    '&:last-child': {
      marginRight: 0,
    },
  },
  iframe: {
    height: '100%',
  },
  visuallyHidden: {
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
    width: 1,
    height: 1,
    margin: -1,
  },
  controlWrapper: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  m0: {
    margin: 0,
  },
  btnControl: {
    [theme.breakpoints.down('md')]: {
      alignSelf: 'flex-end',
    },
  },
}));
